// ./api/user.js
import { authFetch } from "../../api";

export const getUserProfile = async (payload) => {
  try {
    const response = await authFetch(
      `profile/show-primary-information`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching profile:", err.message);
    throw err;
  }
};


// get all the nationalities
export const getAllNationalities = async () => {
  try {
    const response = await authFetch(
      `sap-countries/get-all-nationality`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching nationalities:", err.message);
    throw err;
  }
}

export const getCountries = async () => {
  try {
    const response = await authFetch(
      `sap-countries`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching countries:", err.message);
    throw err;
  }
}


export const getStates = async (country_id) => {
  try {
    const response = await authFetch(
      `sap-states`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country_id }),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching states:", err.message);
    throw err;
  }
}


export const getCities = async (payload) => {
  
  try {
    const response = await authFetch(
      `sap-cities`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching countries:", err.message);
    throw err;
  }
}

export const getLocationByZip = async (zipCode) => {
  try {
    const response = await authFetch(
      `stm-route/country-state-city-bypincode/${zipCode}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching countries:", err.message);
    throw err;
  }
}


export const getMaritalStatus = async () => {
  try {
    const response = await authFetch(
      `maritial-status`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching maritial-status:", err.message);
    throw err;
  }
}

export const savePrimaryInfo = async (payload) => {
  
  try {
    const response = await authFetch(
      `profile/save-primary-information`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching primary info:", err.message);
    throw err;
  }
}
